export const getStatusTextColor = (status: string): string => {
  switch (status) {
    case 'on_hold':
      return '#854d0e'; // Yellow text
    case 'processing':
      return '#166534'; // Green text
    case 'completed':
      return '#1e40af'; // Blue text
    case 'prepare-shipment':
    case 'prepare_shipment':
      return '#c2410c'; // Orange text
    case 'shipped':
      return '#7c3aed'; // Purple text
    case 'cancelled':
      return '#6b7280'; // Gray text
    case 'refunded':
      return '#6b7280'; // Gray text
    case 'failed':
      return '#991b1b'; // Red text
    default:
      return '#000000';
  }
};

export const getStatusBgColor = (status: string): string => {
  switch (status) {
    case 'on_hold':
      return '#fef9c3'; // Light yellow bg
    case 'processing':
      return '#dcfce7'; // Light green bg
    case 'completed':
      return '#dbeafe'; // Light blue bg
    case 'prepare-shipment':
    case 'prepare_shipment':
      return '#ffedd5'; // Light orange bg
    case 'shipped':
      return '#f3e8ff'; // Light purple bg
    case 'cancelled':
      return '#f3f4f6'; // Light gray bg
    case 'refunded':
      return '#f3f4f6'; // Light gray bg
    case 'failed':
      return '#fee2e2'; // Light red bg
    default:
      return '#ffffff';
  }
};
